var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hovering-input flex-center--end"},[_c('div',{staticClass:"input-container"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"edit-button ml-1",on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v("edit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }